// Pure helper for the workspace landing view: flat-walk a tree of
// { type, name, path, mtime?, children? } nodes, collect files, and
// return up to `n` of them sorted by mtime desc. When no file has an
// mtime, fall back to alphabetical by `path` so the output is at
// least deterministic.

export function pickRecentFiles(tree, n) {
  const files = [];
  const walk = (nodes) => {
    for (const node of nodes) {
      if (node.type === 'file') {
        files.push({ path: node.path, name: node.name, mtime: node.mtime });
      } else if (node.type === 'folder' && Array.isArray(node.children)) {
        walk(node.children);
      }
    }
  };
  walk(tree);

  const anyMtime = files.some((f) => typeof f.mtime === 'number');
  if (anyMtime) {
    files.sort((a, b) => (b.mtime ?? -Infinity) - (a.mtime ?? -Infinity));
  } else {
    files.sort((a, b) => (a.path < b.path ? -1 : a.path > b.path ? 1 : 0));
  }
  return files.slice(0, n);
}
